<template>
  <div id="download-app" class="mt-5">
    <div class="container px-5 py-5">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-5 download-content">
          <div class="download-logo">
            <router-link to="/" href="#" title="Govava Gift Store">
              <img
                src="@/assets/site/images/govava-logo-new.png"
                alt="Govava Gifts"
              />
            </router-link>
          </div>
          <h1 class="download-title">Find the perfect gift...</h1>
          <h2 class="mb-4">Download the app today...!</h2>
          <app-store-badges />
        </div>
        <div class="col-md-7">
          <img src="@/assets/site/images/mockup-1.webp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppStoreBadges from "@/components/AppStoreBadges.vue";

export default {
  name: "DownloadApp",
  components: {
    AppStoreBadges,
  },
  metaInfo: {
    title: "Download App",
    meta: [
      {
        name: "description",
        content:
          "Discover the perfect gift for any occasion! Download the Govava app today to explore a wide range of gifts and enjoy a seamless shopping experience",
      },
      {
        name: "keywords",
        content:
          "Download app, Perfect gift, Govava Gifts, App Store, Mobile app, Gift store, User-friendly design, Gift ideas, App download",
      },
    ],
  },
};
</script>
